import { FC } from "react";
import { FormProvider } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";

import { MessagesDisplayContainer, TextboxTemplate } from "@ryde/controls";
import {
  apiDataFetchingLandingAtom,
  landingMessagesAtom,
  VERIFICATION_CODE_PLACE_HOLDER,
  VerifyCodeStepFormFieldsEnum,
} from "@ryde/utils-landings";

import { ContinueButton } from "../../widgets";
import { useStepVerifyCodeHerzliya } from "./use-step-verify-code.herzliya";

export const StepVerifyCodeHerzliya: FC = () => {
  const { methods, handleCodeVerification, resendOtp, isContinueCanBeApply } =
    useStepVerifyCodeHerzliya();
  const landingMessages = useRecoilValue(landingMessagesAtom);
  const isApiLoading = useRecoilValue(apiDataFetchingLandingAtom);
  const { t } = useTranslation();

  return (
    <FormProvider {...methods}>
      <form noValidate onSubmit={e => e.preventDefault()}>
        <div className="landing-top-illustration" aria-hidden="true"></div>
        <h1 className="landing-title">{t("landing.verifyCode.title")}</h1>

        <div className="landing-form-field">
          <label htmlFor={VerifyCodeStepFormFieldsEnum.VerificationCode}>
            {t("landing.formLabel.verificationCode")}*
          </label>
          <TextboxTemplate
            uniqueAttrId={VerifyCodeStepFormFieldsEnum.VerificationCode}
            name={VerifyCodeStepFormFieldsEnum.VerificationCode}
            placeholder={VERIFICATION_CODE_PLACE_HOLDER}
          />
        </div>

        <MessagesDisplayContainer
          serverMessages={landingMessages?.messages}
          type={landingMessages?.type}
        />

        <ContinueButton
          disabled={!isContinueCanBeApply}
          onClick={handleCodeVerification}
          loading={isApiLoading}
        />

        <button type="button" className="blue-link pointer" onClick={resendOtp}>
          {t("general.sendMeAgain")}
        </button>

        <div className="landing-bottom-illustration" aria-hidden="true"></div>

        <div className="landing-container-footer">
          <div
            className="landing-container-footer-logo"
            aria-hidden="true"
          ></div>
        </div>
      </form>
    </FormProvider>
  );
};
